import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-RegularNew.woff2';
import woff from '../src/PPMori-RegularNew.woff';

export const ppMoriRegular: FontFaceSpec = {
  weight: 400,
  style: 'normal',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
